module.exports = "img/cruzFW.d66d97.png";